import classNames from 'classnames'
import gsap from 'gsap'
import React, {useRef, useState} from 'react'
import {render} from 'storyblok-rich-text-react-renderer'

// import Ads from '@/assets/richmenu/Ads'
// import Blog from '@/assets/richmenu/Blog'
// import CanauxMarketing from '@/assets/richmenu/CanauxMarketing'
// import CasClient from '@/assets/richmenu/CasClient'
// import CentreAide from '@/assets/richmenu/CentreAide'
// import DevenirPartenaires from '@/assets/richmenu/DevenirPartenaires'
// import Dialog from '@/assets/richmenu/Dialog'
// import Inudstries from '@/assets/richmenu/Inudstries'
// import Marque from '@/assets/richmenu/Marque'
// import ModulesApi from '@/assets/richmenu/ModulesApi'
// import PartenairesAgences from '@/assets/richmenu/PartenairesAgences'
// import PartenairesEcosystemes from '@/assets/richmenu/PartenairesEcosystemes'
// import PricingMonitoring from '@/assets/richmenu/PricingMonitoring'
// import QuisommesNous from '@/assets/richmenu/QuisommesNous'
// import RepricingMarketplaces from '@/assets/richmenu/RepricingMarketplaces'
// import Retailers from '@/assets/richmenu/Retailers'
// import SyndicationMarketplaces from '@/assets/richmenu/SyndicationMarketplaces'
// import Vendresur from '@/assets/richmenu/Vendresur'
// import Webinaire from '@/assets/richmenu/Webinaire'
// import WebToStore from '@/assets/richmenu/WebToStore.jsx'
import {LogoNavy, LogoNavyInverted} from '@/assets/specify'
import {StoryblokRichtext, TNavigationRichMenu} from '@/common/types'
import {unwrapRenderParagraph} from '@/common/utils'
import LanguageSwitcher from '@/components/LanguageSwitcher'
import Link from '@/components/Link'
import StoryblokImageV2 from '@/components/StoryblokImageV2/StoryblokImageV2'

import styles from './NavigationRichMenu.module.scss'

function isEmptyRichtext(richtext?: StoryblokRichtext | string) {
  return !render(richtext)
}

// const DynamicIcon = ({icon = ''}: {icon?: string}): JSX.Element => {
//   switch (icon) {
//     case 'ads':
//       return <Ads />
//     case 'blog':
//       return <Blog />
//     case 'canauxmarketing':
//       return <CanauxMarketing />
//     case 'casclients':
//       return <CasClient />
//     case 'centreaide':
//       return <CentreAide />
//     case 'devenirpartenaire':
//       return <DevenirPartenaires />
//     case 'dialog':
//       return <Dialog />
//     case 'industries':
//       return <Inudstries />
//     case 'marque':
//       return <Marque />
//     case 'modulesapi':
//       return <ModulesApi />
//     case 'partenairesagences':
//       return <PartenairesAgences />
//     case 'partenairesecosystemes':
//       return <PartenairesEcosystemes />
//     case 'pricingmonitoring':
//       return <PricingMonitoring />
//     case 'quisommesnous':
//       return <QuisommesNous />
//     case 'reprincingmarketing':
//       return <RepricingMarketplaces />
//     case 'retailers':
//       return <Retailers />
//     case 'syndicationmarketplaces':
//       return <SyndicationMarketplaces />
//     case 'vendresur':
//       return <Vendresur />
//     case 'webinaire':
//       return <Webinaire />
//     case 'webtostore':
//       return <WebToStore />
//     default:
//       return <div />
//   }
// }

const NavigationRichMenu = ({
  logo,
  logolight,
  homeLink,
  items = [],
  btnLink,
  btnLabel,
  languages,
  isDark,
}: TNavigationRichMenu): JSX.Element => {
  const mobileSubmenusRefs = useRef<(HTMLDivElement | null)[]>([])
  const [isMenuOpen, setIsMenuOpen] = useState<boolean | null>(false)
  const [mobileSubmenuIndex, setMobileSubmenuIndex] = useState<number | null>(null)

  const storeMobileSubmenus = (el: HTMLDivElement | null, i: number) => {
    mobileSubmenusRefs.current[i] = el
  }

  const handleItemClick = (i: number) => {
    setMobileSubmenuIndex(i)
  }

  React.useEffect(() => {
    if (!isMenuOpen) {
      setMobileSubmenuIndex(null)
    }
  }, [isMenuOpen])

  React.useEffect(() => {
    if (mobileSubmenuIndex !== null && mobileSubmenuIndex >= 0) {
      gsap.set(mobileSubmenusRefs.current[mobileSubmenuIndex], {zIndex: 30, display: 'block'})
    } else {
      gsap.set(mobileSubmenusRefs.current, {zIndex: 10, display: 'none'})
    }
  }, [mobileSubmenuIndex])

  return (
    <section
      className={classNames(styles.menu, {[styles.open]: isMenuOpen}, {[styles.dark]: isDark})}
    >
      <nav className={styles.section}>
        <div className={styles.nav}>
          <Link link={homeLink} className={styles.logoLink}>
            {isDark && !isMenuOpen && logolight && logolight.filename !== '' ? (
              <StoryblokImageV2
                filename={logolight.filename}
                alt={logolight.alt}
                sizes={{sm: 180, unit: 'px'}}
                width='180'
                fixedWidth={180}
              />
            ) : isDark && isMenuOpen && logo && logo.filename !== '' ? (
              <StoryblokImageV2
                filename={logo.filename}
                alt={logo.alt}
                sizes={{sm: 180, unit: 'px'}}
                width='180'
                fixedWidth={180}
              />
            ) : isDark && !isMenuOpen ? (
              <LogoNavyInverted title='Home' style={{height: '100%'}} />
            ) : isDark && isMenuOpen ? (
              <LogoNavy title='Home' style={{height: '100%'}} />
            ) : (
              <LogoNavy title='Home' style={{height: '100%'}} />
            )}
          </Link>

          <div className={styles.items}>
            {items.map((item) => (
              <div key={item._uid} className={styles.item}>
                <p className={styles.itemlabel}>{item.label}</p>
                <svg width='18' height='18' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='m4.5 6.75 4.5 4.5 4.5-4.5'
                    stroke='#221F61'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>

                <div className={styles.dropdown}>
                  <div className={styles.innerdropdown}>
                    <div className={styles.innerdropdowncontent}>
                      <p className={styles.dropdownlabel}>{item.label}</p>
                      <div className={styles.innerdropdowncontentrow}>
                        {item.items &&
                          item.items.length > 0 &&
                          item.items.map((item) => {
                            if (item.component !== 'navigation-rich-submenu-list') return null
                            return (
                              <div key={item._uid} className={styles.innerdropdowncontentcol}>
                                {item.title && item.title !== '' && (
                                  <p className={styles.innerdropdowncontentcoltitle}>
                                    {item.title}
                                  </p>
                                )}
                                {item.items && item.items.length > 0 && (
                                  <ul className={styles.innerdropdowncontentcolul}>
                                    {item.items.map((item) => {
                                      const {icon} = item
                                      return (
                                        <li
                                          key={item._uid}
                                          className={styles.innerdropdowncontentcolli}
                                        >
                                          <span className={styles.innerdropdowncontentcolliicon}>
                                            <div
                                              className={
                                                styles.innerdropdowncontentcolliiconwrapper
                                              }
                                            >
                                              {icon && icon.filename !== '' && (
                                                <StoryblokImageV2
                                                  filename={icon.filename}
                                                  alt={icon.alt}
                                                />
                                              )}
                                            </div>
                                          </span>
                                          <span>
                                            <Link
                                              link={item.link}
                                              className={styles.mobilemenucollink}
                                            >
                                              <span className={styles.mobilemenucollinklabel}>
                                                {item.label}
                                              </span>
                                              {!isEmptyRichtext(item.description) ? (
                                                <span className={styles.mobilemenucollinkdesc}>
                                                  {render(item.description)}
                                                </span>
                                              ) : (
                                                <span className={styles.mobilemenucollinkdesc}>
                                                  ---
                                                </span>
                                              )}
                                            </Link>
                                          </span>
                                        </li>
                                      )
                                    })}
                                  </ul>
                                )}
                              </div>
                            )
                          })}
                      </div>
                    </div>

                    <div className={styles.innerdropdownad}>
                      {item.page &&
                        item.page.length > 0 &&
                        item.page.map((item) => {
                          if (item.component === 'navigation-rich-submenu-page') {
                            return (
                              <div key={item._uid} className={styles.innerdropdownadbutton}>
                                <Link link={item.link}>
                                  {item.illustration && item.illustration.filename !== '' && (
                                    <div className={styles.illustration}>
                                      <StoryblokImageV2
                                        filename={item.illustration.filename}
                                        alt={item.illustration.alt}
                                      />
                                    </div>
                                  )}
                                  <div className={styles.innerdropdownadbuttonrow}>
                                    <p className={styles.innerdropdownadbuttonlabel}>
                                      {item.title}
                                    </p>
                                    <svg
                                      width='24'
                                      height='25'
                                      viewBox='0 0 24 25'
                                      fill='none'
                                      xmlns='http://www.w3.org/2000/svg'
                                    >
                                      <path
                                        d='M6 12.5H18.5M18.5 12.5L12.5 6.5M18.5 12.5L12.5 18.5'
                                        stroke='black'
                                        strokeWidth='1.5'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                      />
                                    </svg>
                                  </div>
                                  <p className={styles.innerdropdownadbuttondesc}>
                                    {render(item.description, unwrapRenderParagraph)}
                                  </p>
                                </Link>

                                <div className={styles.semisphere}>
                                  <img src={'/semisphere3D.png'} alt='semi sphere illustration' />
                                </div>

                                {item.avatar && item.avatar.filename !== '' && (
                                  <div className={styles.avatar}>
                                    <StoryblokImageV2
                                      filename={item.avatar.filename}
                                      alt={item.avatar.alt}
                                    />
                                  </div>
                                )}
                              </div>
                            )
                          } else if (item.component === 'navigation-rich-submenu-resources') {
                            const {items = []} = item
                            return (
                              <div key={item._uid} className={styles.innerdropdownresourcessection}>
                                <div className={styles.innerdropdownresourcessectiontitle}>
                                  {item.title}
                                </div>
                                <div className={styles.innerdropdownresourcesitemswrapper}>
                                  {items.length > 0 &&
                                    item.items?.map((item) => {
                                      const {_uid, title, description, illustration} = item
                                      return (
                                        <Link
                                          key={_uid}
                                          link={item.link}
                                          className={styles.innerdropdownresourcesitem}
                                        >
                                          <span className={styles.innerdropdownresourcesitemillu}>
                                            {illustration && illustration.filename !== '' && (
                                              <StoryblokImageV2
                                                filename={illustration.filename}
                                                alt={illustration.alt}
                                              />
                                            )}
                                          </span>
                                          <p className={styles.innerdropdownresourcesitemtitle}>
                                            {title}
                                          </p>
                                          <p className={styles.innerdropdownresourcesitemdesc}>
                                            {render(description, unwrapRenderParagraph)}
                                          </p>
                                        </Link>
                                      )
                                    })}
                                </div>
                              </div>
                            )
                          } else {
                            return null
                          }
                        })}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className={styles.buttonWrapper}>
            {btnLink && btnLabel && (
              <Link label={btnLabel} link={btnLink} className={styles.button} />
            )}
          </div>

          {btnLink && btnLabel && languages && <hr className={styles.divider} />}

          {languages && (
            <div className={styles.desktopLangWrapper}>
              <LanguageSwitcher languages={languages} isLight={!!isDark} />
            </div>
          )}

          <button className={styles.toggleMobileMenu} onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? (
              <svg
                width='25'
                height='24'
                viewBox='0 0 25 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M7.18893 17.2426L12.4316 12M17.6742 6.75736L12.4316 12M12.4316 12L7.18893 6.75736M12.4316 12L17.6742 17.2426'
                  stroke='#221F61'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            ) : (
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <rect x='6' y='6' width='12' height='2' fill='#221F61' />
                <rect x='6' y='16' width='12' height='2' fill='#221F61' />
                <rect x='6' y='11' width='12' height='2' fill='#221F61' />
              </svg>
            )}
          </button>
        </div>
      </nav>

      <div className={classNames(styles.mobileMenu, {[styles.open]: isMenuOpen})}>
        <div className={styles.mobileSubmenuContainer}>
          <div className={styles.mobileList}>
            {items.map((item, i) => (
              <button
                key={item._uid}
                className={styles.mobileListItem}
                onClick={() => handleItemClick(i)}
              >
                <p className={styles.mobileListItemLabel}>{item.label}</p>
                <svg width='18' height='18' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='m4.5 6.75 4.5 4.5 4.5-4.5'
                    stroke='#221F61'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </button>
            ))}
          </div>

          {items.map((item, i) => {
            return (
              <div
                key={item._uid}
                className={styles.mobileSubmenu}
                ref={(el) => storeMobileSubmenus(el, i)}
              >
                <button className={styles.mobilemenutitlecol} onClick={() => handleItemClick(-1)}>
                  <svg width='18' height='18' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='m4.5 6.75 4.5 4.5 4.5-4.5'
                      stroke='#221F61'
                      strokeWidth='1.5'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                  <p>{item.label}</p>
                </button>

                {item.items &&
                  item.items.length > 0 &&
                  item.items.map((item) => {
                    if (item.component !== 'navigation-rich-submenu-list') return null
                    return (
                      <div key={item._uid} className={styles.mobilemenucol}>
                        <p className={styles.mobilemenucoltitle}>{item.title}</p>

                        <ul className={styles.mobilemenucolul}>
                          {item.items &&
                            item.items.length > 0 &&
                            item.items.map((item) => {
                              const {icon} = item
                              return (
                                <li key={item._uid} className={styles.mobilemenucolli}>
                                  <span className={styles.mobilemenucolliicon}>
                                    <div className={styles.mobilemenucolliiconwrapper}>
                                      {icon && icon.filename !== '' && (
                                        <StoryblokImageV2 filename={icon.filename} alt={icon.alt} />
                                      )}
                                    </div>
                                  </span>

                                  <Link link={item.link} className={styles.mobilemenucollink}>
                                    <span className={styles.mobilemenucollinklabel}>
                                      {item.label}
                                    </span>
                                    {!isEmptyRichtext(item.description) ? (
                                      <span className={styles.mobilemenucollinkdesc}>
                                        {render(item.description)}
                                      </span>
                                    ) : (
                                      <span className={styles.mobilemenucollinkdesc}>---</span>
                                    )}
                                  </Link>
                                </li>
                              )
                            })}
                        </ul>
                      </div>
                    )
                  })}

                {item.page &&
                  item.page.length > 0 &&
                  item.page.map((item) => {
                    if (item.component === 'navigation-rich-submenu-page') {
                      return (
                        <div key={item._uid} className={styles.mobilemenuad}>
                          <Link link={item.link} className={styles.mobilemenuadbutton}>
                            {item.illustration && item.illustration.filename !== '' && (
                              <div className={styles.mobilemenuadbuttonillustration}>
                                <StoryblokImageV2
                                  filename={item.illustration.filename}
                                  alt={item.illustration.alt}
                                />
                              </div>
                            )}
                            <div className={styles.mobilemenuadbuttonbuttonrow}>
                              <p className={styles.mobilemenuadbuttonbuttonlabel}>{item.title}</p>
                              <svg
                                width='24'
                                height='25'
                                viewBox='0 0 24 25'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M6 12.5H18.5M18.5 12.5L12.5 6.5M18.5 12.5L12.5 18.5'
                                  stroke='black'
                                  strokeWidth='1.5'
                                  strokeLinecap='round'
                                  strokeLinejoin='round'
                                />
                              </svg>
                            </div>
                            <p className={styles.mobilemenuadbuttonbuttondesc}>
                              {render(item.description, unwrapRenderParagraph)}
                            </p>
                          </Link>

                          {item.avatar && item.avatar.filename !== '' && (
                            <div className={styles.mobilemenuadavatar}>
                              <StoryblokImageV2
                                filename={item.avatar.filename}
                                alt={item.avatar.alt}
                              />
                            </div>
                          )}
                        </div>
                      )
                    } else if (item.component === 'navigation-rich-submenu-resources') {
                      const {items = []} = item
                      return (
                        <div key={item._uid} className={styles.mobilemenuresources}>
                          <div className={styles.mobilemenuresourcestitle}>{item.title}</div>
                          <div className={styles.mobilemenuresourcesitemswrapper}>
                            <div
                              className={styles.mobilemenuresourcesitemsinnerwrapper}
                              style={{width: `${136 * items.length}px`}}
                            >
                              {items.length > 0 &&
                                item.items?.map((item) => {
                                  const {_uid, title, description, illustration} = item
                                  return (
                                    <Link
                                      key={_uid}
                                      link={item.link}
                                      className={styles.mobilemenuresourcesitem}
                                    >
                                      <span className={styles.mobilemenuresourcesitemillu}>
                                        {illustration && illustration.filename !== '' && (
                                          <StoryblokImageV2
                                            filename={illustration.filename}
                                            alt={illustration.alt}
                                          />
                                        )}
                                      </span>
                                      <p className={styles.mobilemenuresourcesitemtitle}>{title}</p>
                                      <p className={styles.mobilemenuresourcesitemdesc}>
                                        {render(description, unwrapRenderParagraph)}
                                      </p>
                                    </Link>
                                  )
                                })}
                            </div>
                          </div>
                        </div>
                      )
                    } else {
                      return null
                    }
                  })}
              </div>
            )
          })}
        </div>
      </div>

      <div className={styles.stickybottomMobile}>
        <div className={styles.buttonWrapper}>
          {btnLink && btnLabel && (
            <Link label={btnLabel} link={btnLink} className={styles.button} />
          )}
        </div>

        {languages && (
          <div className={styles.desktopLangWrapper}>
            <LanguageSwitcher languages={languages} isLight={false} isTop={true} />
          </div>
        )}
      </div>
    </section>
  )
}

export default NavigationRichMenu
